import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from '@/auth/config';
import App from './App';
import './index.css';

function renderFatal(message: string) {
  const root = document.getElementById('root');
  if (!root) return;
  root.innerHTML = `<div style="padding:2rem;max-width:32rem;margin:2rem auto;font-family:system-ui,sans-serif"><h1 style="margin:0 0 1rem">SILISENSE</h1><p style="color:#64748b;line-height:1.5">${message}</p></div>`;
}

// MSAL must be initialized before render (required for redirect flow)
msalInstance
  .initialize()
  .then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
      </React.StrictMode>
    );
  })
  .catch((err: unknown) => {
    console.error('MSAL initialize failed', err);
    renderFatal(
      'Sign-in could not start. If this persists after a refresh, the app may not be deployed correctly — contact support.'
    );
  });
